import { formatHqlValue, formatUnitFields } from '@/lib/hqlFormat';
import type { HomeDocumentUnit, HqlFacts } from '@rock/hql';
import type { FC } from 'react';

/**
 * The slice of a home a query read: each info answer it asked about, and each unit it looked at,
 * marked matched or not.
 */
export const QueryFacts: FC<{ facts: HqlFacts; matched: ReadonlySet<string> }> = ({ facts, matched }) => {
    const infoEntries = Object.entries(facts.info);
    return (
        <>
            {infoEntries.length > 0 ? (
                <div className="space-y-1">
                    <div className="text-sm text-muted-foreground">Home facts it read</div>
                    <ul className="font-mono text-sm">
                        {infoEntries.map(([key, value]) => (
                            <li key={key}>
                                {key}:{' '}
                                {value === null ? (
                                    <span className="text-muted-foreground">unknown</span>
                                ) : (
                                    formatHqlValue(value)
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}
            {facts.equipment.length > 0 ? (
                <div className="space-y-1">
                    <div className="text-sm text-muted-foreground">Equipment it looked at</div>
                    <ul className="space-y-1">
                        {facts.equipment.map((unit) => (
                            <UnitLine key={unit.id} unit={unit} matched={matched.has(unit.id)} />
                        ))}
                    </ul>
                </div>
            ) : null}
        </>
    );
};

const UnitLine: FC<{ unit: HomeDocumentUnit; matched: boolean }> = ({ unit, matched }) => (
    <li
        className={`rounded-md border p-2 text-sm ${matched ? 'border-green-300 bg-green-50' : 'text-muted-foreground'}`}
    >
        <div className="flex items-center gap-2">
            <span className="font-medium">{matched ? 'Matched' : 'Not matched'}</span>
            <span className="font-mono">{unit.typeId}</span>
            <span className="font-mono text-xs">{unit.id}</span>
            {unit.brandId ? <span className="text-xs">brand id {unit.brandId}</span> : null}
        </div>
        <div className="font-mono text-xs">{formatUnitFields(unit.fields)}</div>
    </li>
);
